/**
 * 音频淡入淡出工具（与 constants.js 中的 FADE_TICK_MS、getFadeStep 配合使用）
 */
import { FADE_TICK_MS, getFadeStep } from './constants';

/**
 * 淡入：从 0 渐变到 targetVolume
 * @param {HTMLMediaElement} mediaEl - 媒体元素
 * @param {number} targetVolume - 目标音量 (0-1)
 * @param {() => void} [onComplete] - 完成回调（可选）
 * @returns {number|void} 返回 interval id，供调用方需要时 clearInterval
 */
export const runFadeIn = (mediaEl, targetVolume, onComplete) => {
  if (!mediaEl || targetVolume <= 0) {
    if (onComplete) onComplete();
    return;
  }
  let currentVol = 0;
  const step = getFadeStep(0, targetVolume);
  const fadeInterval = setInterval(() => {
    currentVol += step;
    if (currentVol >= targetVolume) {
      mediaEl.volume = targetVolume;
      clearInterval(fadeInterval);
      if (onComplete) onComplete();
    } else {
      mediaEl.volume = currentVol;
    }
  }, FADE_TICK_MS);
  return fadeInterval;
};

/**
 * 淡出：从当前音量渐变到 0
 * @param {HTMLMediaElement} mediaEl - 媒体元素
 * @param {() => void} onComplete - 完成回调（音量归零后调用）
 * @returns {number} 返回 interval id，供调用方 clearInterval 取消
 */
export const runFadeOut = (mediaEl, onComplete) => {
  if (!mediaEl) {
    if (onComplete) onComplete();
    return 0;
  }
  let currentVol = mediaEl.volume;
  const step = getFadeStep(currentVol, 0);
  if (currentVol <= 0) {
    if (onComplete) onComplete();
    return 0;
  }
  const fadeInterval = setInterval(() => {
    currentVol -= step;
    if (currentVol <= 0) {
      mediaEl.volume = 0;
      clearInterval(fadeInterval);
      if (onComplete) onComplete();
    } else {
      mediaEl.volume = currentVol;
    }
  }, FADE_TICK_MS);
  return fadeInterval;
};
